// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The well-known name of the file. Can actually be configured by alternate
 * implementations, but the default is probably good enough for "best-effort."
 */
export const THIRD_PARTY_LICENSES = 'third-party-licenses.json';
/**
 * The token for the licenses service.
 */
export const ILicenses = new Token('@jupyterlite/licenses:ILicenses');
//# sourceMappingURL=tokens.js.map